import React, { useEffect, useState } from 'react';
import './css/OnlineExam.css';

// Reusing your standalone, modular layout components
import Navbar from './components/Navbar';
import Newsletter from './components/NewsLetter';
import Footer from './components/Footer';

// Import your custom images here
import examHeroBg from '../images/banner-online-exams.jpg';
// import tabSectionBg from '../images/Banner2.png'; // Background for the new interactive tab section
import showcaseImage from '../images/onlineExamRight.png'; // Preview image for the right side

import twinBg from "../images/Banner5.png"; // New background image asset
import circle2Icon1 from "../images/HomeIcon.png"; // Icon for the first circle
import circle2Icon2 from "../images/HomeIcon.png"; // Icon for the second circle
import circle2Icon3 from "../images/CardImage2.png"; // Icon for the first circle
import circle2Icon4 from "../images/CardImage3.png"; // Icon for the second circle

import featureSectionBg2 from '../images/Banner3.png'; // New Background Import
import Why1 from '../images/mathicon1.png';
import Why2 from '../images/scienceicon1.png';
import Why3 from '../images/social-scienceicon1.png';
import Why4 from '../images/apptitude.png';
import DownloadAppLMS from './components/DownloadAppLMS';

function OnlineExam() {
    // State to track the active tab index (0 to 3)
    const [activeTab, setActiveTab] = useState(0);

    // State to control YouTube Video Popup Modal visibility
    const [isVideoModalOpen, setIsVideoModalOpen] = useState(false);

    // Tab content data structure
    const tabData = [
        {
            title: "Facilitate Self Discovery (FSD)",
            description:
                "We encourage students to treat this as the first step towards assessing their current academic status. Crestest offers three kinds of online tests—Chapter Tests, Module Tests, and Mock Tests. Chapter Tests focus on individual chapters, while Module Tests cover multiple chapters for a broader evaluation. Mock Tests are designed as the final stage of preparation before students appear for their board or competitive examinations. In addition, a wide range of practice tests is available for various competitive exams, helping students measure their progress, identify improvement areas, and prepare with confidence."
        },
        {
            title: "Demo",
            description:
                "Crestest provides two types of demo experiences—one for Guest Users and another for Registered Users. Anyone can take sample tests and explore the platform's interface, features, and examination environment. Users who register with a free account gain additional benefits, including access to detailed performance assessments and personalized analysis after completing a test. This allows learners to experience the platform before choosing a subscription plan."
        },
        {
            title: "Spectrum",
            description:
                "Crestest offers two comprehensive learning streams—Scholastic and Competitive. The Scholastic section includes Chapter Tests, Module Tests, and Mock Tests across all subjects, with questions intelligently selected from an extensive question bank by our automated system. Students are allowed a maximum of three attempts for each test, after which the test is automatically submitted. For Competitive examinations, practice papers are generated using previous years' examination patterns, ensuring students practice questions in the same proportion and format prescribed by the respective examination authorities."
        },
        {
            title: "Your Choice",
            description:
                "Students have the flexibility to subscribe only to the subjects in which they require support, making the learning experience both personalized and cost-effective. There is no obligation to purchase the complete course offering. As students become familiar with the platform and develop confidence in Crestest's learning approach, they can upgrade at any time to access additional subjects or unlock the complete question bank according to their individual learning needs and academic goals."
        }
    ];

    // State to control the popup modal visibility
    const [showModal, setShowModal] = useState(false);

    // Automatically scroll to top when visiting the Founders page
    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    const handleOpenModal = (e) => {
        e.preventDefault();
        setShowModal(true);
    };

    const handleCloseModal = () => {
        setShowModal(false);
    };

    return (
        <div className="online-exam-page-wrapper">

            {/* 1. Header Hero Section with integrated clean Navbar */}
            <section
                className="online-exam-hero-section"
                style={{ backgroundImage: `url(${examHeroBg})` }}
            >
                <Navbar />
            </section>

            {/* 3. New Interactive Tab & Video Showcase Section */}
            <section
                className="online-exam-interactive-section"
            // style={{ backgroundImage: `url(${tabSectionBg})` }}
            >
                <div className="container-fluid p-0">
                    <div className="row g-0 align-items-center">

                        {/* Left Part: 4 Tabs in a row with dynamic sub-description */}
                        <div className="col-lg-6 px-lg-5 py-5">
                            <div className="interactive-left-content">
                                <span className="interactive-mini-tag" style={{ color: '#083c66' }}>WORKFLOW ENGINE</span>
                                <h2 className="interactive-heading" style={{ color: '#FBBB1B' }}>
                                    Streamlined Testing Experience
                                </h2>
                                <div className="zigzag-border mt-2 mb-4" style={{ backgroundColor: '#083c66' }}></div>

                                {/* 4 Tabs Row */}
                                <div className="exam-tabs-header-row">
                                    {tabData.map((tab, index) => (
                                        <button
                                            key={index}
                                            className={`exam-tab-btn ${activeTab === index ? 'active' : ''}`}
                                            onClick={() => setActiveTab(index)}
                                        >
                                            {tab.title}
                                        </button>
                                    ))}
                                </div>

                                {/* Dynamic Sub-description Container */}
                                <div className="exam-tab-content-box">
                                    <h4 className="tab-dynamic-title">{tabData[activeTab].title} Workflow</h4>
                                    <p className="tab-dynamic-desc">{tabData[activeTab].description}</p>
                                </div>
                            </div>
                        </div>

                        {/* Right Part: Reduced image sizing cleanly centered with play button */}
                        <div className="col-lg-6 position-relative video-showcase-col">
                            <div className="video-bg-wrapper">
                                <img src={showcaseImage} alt="Platform Showcase Preview" className="showcase-img" />

                                {/* Center-aligned custom play button */}
                                <button
                                    className="custom-center-play-btn"
                                    onClick={() => setIsVideoModalOpen(true)}
                                    aria-label="Play video showcase"
                                >
                                    <span className="play-icon-triangle"></span>
                                </button>
                            </div>
                        </div>

                    </div>
                </div>
            </section>

            {/* Customized Premium Bordered Popup Modal for YouTube Video */}
            {isVideoModalOpen && (
                <div className="premium-video-modal-backdrop" onClick={() => setIsVideoModalOpen(false)}>
                    <div className="premium-video-modal-container" onClick={(e) => e.stopPropagation()}>
                        <button
                            className="premium-modal-close-btn"
                            onClick={() => setIsVideoModalOpen(false)}
                            aria-label="Close modal"
                        >
                            &times;
                        </button>
                        <div className="premium-video-frame-wrapper">
                            <iframe
                                className="youtube-iframe-embed"
                                src="https://www.youtube.com/embed/8LxRen9j61s?autoplay=1"
                                title="Platform Showcase Video"
                                frameBorder="0"
                                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                                allowFullScreen
                            ></iframe>
                        </div>
                    </div>
                </div>
            )}

            {/* 2. Content Section matching style theme */}
            <section className="about-grid-bg-section" style={{ backgroundImage: `url(${featureSectionBg2})` }}>
                <div className="container">

                    {/* Centralized Section Header */}
                    <div className="row justify-content-center text-center mb-5">
                        <div className="col-lg-8">
                            <span className="grid-section-mini-tag">OUR ACADEMIC PROGRAMS</span>
                            <h2 className="grid-section-heading">
                                Comprehensive Learning Across Core Subjects
                            </h2>
                            <div className="zigzag-border mx-auto mt-3"></div>
                        </div>
                    </div>
                    {/* 2 Cards Per Row */}
                    <div className="row g-4 justify-content-center">

                        {/* Mission */}
                        <div className="col-lg-6">
                            <div className="glass-grid-box">
                                <div className="subject-card-new">

                                    {/* Top Header */}
                                    <div className="subject-card-header">
                                        <div className="subject-icon-box">
                                            <img
                                                src={Why1}
                                                alt="Mathematics"
                                                className="subject-icon-img"
                                            />
                                        </div>

                                        <h4 className="subject-title">
                                            Mathematics
                                        </h4>
                                    </div>

                                    {/* Description */}
                                    <p className="subject-description">
                                        Comprehensive Mathematics learning for <strong>CBSE & ICSE (Classes 7–10)</strong> with structured tests, practice, and exam preparation.
                                    </p>

                                    {/* Two Column Features */}
                                    <div className="subject-features">
                                        <ul>
                                            <li>CBSE & ICSE (Classes 7–10)</li>
                                            <li>Chapter-wise Tests</li>
                                            <li>Unit Tests</li>
                                        </ul>

                                        <ul>
                                            <li>Mock Tests</li>
                                            <li>Practice Sets</li>
                                            <li>Aptitude Practice</li>
                                        </ul>
                                    </div>

                                </div>
                            </div>
                        </div>

                        {/* Approach */}
                        <div className="col-lg-6">
                            <div className="glass-grid-box">
                                <div className="subject-card-new">

                                    {/* Header */}
                                    <div className="subject-card-header">
                                        <div
                                            className="subject-icon-box"
                                            style={{ backgroundColor: "rgb(7, 68, 59)", border: "2px solid #207AB4" }}
                                        >
                                            <img
                                                src={Why2}
                                                alt="Science"
                                                className="subject-icon-img"
                                            />
                                        </div>

                                        <h4 className="subject-title">Science</h4>
                                    </div>

                                    {/* Description */}
                                    <p className="subject-description">
                                        Comprehensive Science learning for <strong>CBSE & ICSE (Classes 7–10)</strong> with structured assessments, practical learning, and exam-focused preparation.
                                    </p>

                                    {/* Features */}
                                    <div className="subject-features">
                                        <ul>
                                            <li>CBSE & ICSE (Classes 7–10)</li>
                                            <li>Chapter-wise Tests</li>
                                            <li>Unit Tests</li>
                                        </ul>

                                        <ul>
                                            <li>Mock Tests</li>
                                            <li>Practice Sets</li>
                                            <li>Concept-Based Learning</li>
                                        </ul>
                                    </div>

                                </div>
                            </div>
                        </div>

                        {/* Social Science */}
                        <div className="col-lg-6">
                            <div className="glass-grid-box">
                                <div className="subject-card-new">

                                    {/* Header */}
                                    <div className="subject-card-header">
                                        <div
                                            className="subject-icon-box"
                                            style={{ backgroundColor: "rgb(102, 8, 89)", border: "2px solid #FBBB1B" }}
                                        >
                                            <img
                                                src={Why3}
                                                alt="Social Science"
                                                className="subject-icon-img"
                                            />
                                        </div>

                                        <h4 className="subject-title">Social Science</h4>
                                    </div>

                                    {/* Description */}
                                    <p className="subject-description">
                                        Comprehensive Social Science learning for <strong>CBSE & ICSE (Classes 7–10)</strong> with structured assessments, concept clarity, and exam-focused preparation.
                                    </p>

                                    {/* Features */}
                                    <div className="subject-features">
                                        <ul>
                                            <li>CBSE & ICSE (Classes 7–10)</li>
                                            <li>Chapter-wise Tests</li>
                                            <li>Unit Tests</li>
                                        </ul>

                                        <ul>
                                            <li>Mock Tests</li>
                                            <li>Practice Sets</li>
                                            <li>Map & Concept Practice</li>
                                        </ul>
                                    </div>

                                </div>
                            </div>
                        </div>

                        {/* Aptitude */}
                        <div className="col-lg-6">
                            <div className="glass-grid-box">
                                <div className="subject-card-new">

                                    {/* Header */}
                                    <div className="subject-card-header">
                                        <div
                                            className="subject-icon-box"
                                            style={{ backgroundColor: "rgb(8 58 102)", border: "2px solid #FBBB1B" }}
                                        >
                                            <img
                                                src={Why4}
                                                alt="Aptitude"
                                                className="subject-icon-img"
                                            />
                                        </div>

                                        <h4 className="subject-title">Aptitude</h4>
                                    </div>

                                    {/* Description */}
                                    <p className="subject-description">
                                        Comprehensive Aptitude training for <strong>competitive exams</strong> to enhance logical reasoning, analytical thinking, and problem-solving skills.
                                    </p>

                                    {/* Features */}
                                    <div className="subject-features">
                                        <ul>
                                            <li>Logical Reasoning</li>
                                            <li>Quantitative Aptitude</li>
                                            <li>Analytical Thinking</li>
                                        </ul>

                                        <ul>
                                            <li>Practice Sets</li>
                                            <li>Mock Tests</li>
                                            <li>Speed & Accuracy Tests</li>
                                        </ul>
                                    </div>

                                </div>
                            </div>
                        </div>

                    </div>

                    {/* View More Subjects Button Trigger */}
                    <div className="row mt-4">
                        <div className="col-12 text-center">
                            <button onClick={handleOpenModal} className="btn info-btn">
                                VIEW MORE SUBJECTS
                            </button>
                        </div>
                    </div>
                </div>
            </section>

            {/* ==========================================================
                BOOTSTRAP MODAL SECTION (Standard Bootstrap Classes)
                ========================================================== */}
            {showModal && (
                <div className="modal fade show d-block" tabIndex="-1" style={{ backgroundColor: 'rgba(0,0,0,0.5)' }}>
                    <div className="modal-dialog modal-dialog-centered">
                        <div className="modal-content shadow-lg border-0 rounded-4">

                            <div className="modal-header border-bottom px-4 py-3">
                                <h5 className="modal-title fw-bold" style={{ color: '#207AB4' }}>Select Academic Section</h5>
                                <button type="button" className="btn-close" onClick={handleCloseModal}></button>
                            </div>

                            <div className="modal-body p-4">
                                <p className="text-muted small mb-4">Choose a curriculum section below to explore interactive learning portals:</p>

                                <div className="d-grid gap-3">
                                    <a
                                        href="https://cbse.crestest.com"
                                        target="_blank"
                                        rel="noopener noreferrer"
                                        className="btn btn-outline-primary py-3 px-3 text-start d-flex flex-column rounded-3"
                                        style={{ borderColor: '#207AB4', color: '#207AB4' }}
                                    >
                                        <strong className="fs-6">CBSE Section</strong>
                                        <span className="text-muted small">Explore curriculum-aligned learning materials</span>
                                    </a>

                                    <a
                                        href="https://icse.crestest.com"
                                        target="_blank"
                                        rel="noopener noreferrer"
                                        className="btn btn-outline-info py-3 px-3 text-start d-flex flex-column rounded-3"
                                        style={{ borderColor: '#57BDB9', color: '#207AB4' }}
                                    >
                                        <strong className="fs-6">ICSE Section</strong>
                                        <span className="text-muted small">Deep conceptual clarity for ICSE students</span>
                                    </a>

                                    <a
                                        href="https://ntse.crestest.com"
                                        target="_blank"
                                        rel="noopener noreferrer"
                                        className="btn btn-outline-warning py-3 px-3 text-start d-flex flex-column rounded-3"
                                        style={{ borderColor: '#FBBB1B', color: '#207AB4' }}
                                    >
                                        <strong className="fs-6">NTSE Section</strong>
                                        <span className="text-muted small">National Talent Search Examination preparation modules</span>
                                    </a>
                                </div>
                            </div>

                            <div className="modal-footer border-top px-4 py-3 bg-light rounded-bottom-4">
                                <button type="button" className="btn btn-secondary btn-sm px-4" onClick={handleCloseModal}>
                                    Close
                                </button>
                            </div>

                        </div>
                    </div>
                </div>
            )}

            {/* Download App Section */}
            <DownloadAppLMS />

            {/* 4. NEW: Overlapping Dual Card Section */}
            <section
                className="twin-cards-section"
                style={{ backgroundImage: `url(${twinBg})` }}
            >
                <div className="container">

                    {/* Section Header (Center Aligned) */}
                    <div className="row justify-content-center text-center twin-header-margin">
                        <div className="col-lg-8 d-flex flex-column align-items-center">
                            <p className="cards-small-text" style={{ color: '#0f507a' }}>
                                SMART LEARNING TOOLS
                            </p>

                            <h2 className="cards-main-heading" style={{ color: '#FBBB1B' }}>
                                Learn, Track & Improve with Confidence
                            </h2>

                            <div
                                className="zigzag-border"
                                style={{ backgroundColor: '#FBBB1B' }}
                            ></div>
                        </div>
                    </div>

                    {/* Dual Cards Row */}
                    <div className="row g-5 justify-content-center twin-row-padding">

                        {/* Left Card */}
                        <div className="col-md-6 col-lg-5">
                            <div className="overlap-card">

                                {/* Floating Circle */}
                                <div className="floating-top-circle bg-circle-accent1">
                                    <img src={circle2Icon1} alt="E-Library" className="floating-circle-icon" />
                                </div>

                                {/* Card Content */}
                                <div className="overlap-card-body text-center d-flex flex-column align-items-center">
                                    <img
                                        src={circle2Icon3}
                                        alt="E-Library Illustration"
                                        className="overlap-card-top-image"
                                    />

                                    <h4
                                        className="mb-3"
                                        style={{
                                            color: "#207AB4",
                                            fontWeight: "700",
                                            fontSize: "1.6rem",
                                            letterSpacing: "0.5px",
                                            textTransform: "capitalize"
                                        }}
                                    >
                                        E-Library
                                    </h4>

                                    <p className="overlap-sub-text">
                                        The clear and concise combination of concept maps and written notes
                                        promotes deeper understanding, better retention, and supports
                                        different learning styles. This enriched learning experience enhances
                                        students' ability to learn, retain, and recall concepts, helping
                                        them perform with confidence in both scholastic and competitive
                                        examinations.
                                    </p>

                                    <a
                                        href="/e-library"
                                        className="overlap-colored-action text-decoration-none"
                                        style={{ color: '#207AB4' }}
                                    >
                                        EXPLORE E-LIBRARY
                                    </a>
                                </div>

                            </div>
                        </div>

                        {/* Right Card */}
                        <div className="col-md-6 col-lg-5">
                            <div className="overlap-card">

                                {/* Floating Circle */}
                                <div className="floating-top-circle bg-circle-accent2">
                                    <img
                                        src={circle2Icon2}
                                        alt="Performance Scorecard"
                                        className="floating-circle-icon"
                                    />
                                </div>

                                {/* Card Content */}
                                <div className="overlap-card-body text-center d-flex flex-column align-items-center">
                                    <img
                                        src={circle2Icon4}
                                        alt="Performance Scorecard Illustration"
                                        className="overlap-card-top-image"
                                    />

                                    <h4
                                        className="mb-3"
                                        style={{
                                            color: "#57BDB9",
                                            fontWeight: "700",
                                            fontSize: "1.6rem",
                                            letterSpacing: "0.5px",
                                            textTransform: "capitalize"
                                        }}
                                    >
                                        Performance Scorecard
                                    </h4>

                                    <p className="overlap-sub-text">
                                        Our Performance Scorecard provides a comprehensive view of a
                                        student's progress through detailed statistics and interactive
                                        graphs. It identifies strengths, highlights areas that need
                                        improvement, and enables learners to compare scholastic and
                                        competitive performance through a dynamic, data-driven interface.
                                    </p>

                                    <a
                                        href="/performance-scorecard"
                                        className="overlap-colored-action text-decoration-none"
                                        style={{ color: '#57BDB9' }}
                                    >
                                        VIEW SCORECARD
                                    </a>

                                </div>

                            </div>
                        </div>

                    </div>
                </div>
            </section>





            {/* Bottom Global Components */}
            <Newsletter />
            <Footer />

        </div>
    );
}

export default OnlineExam;

